module.exports = __webpack_public_path__ + "img/logo-icon.e205ab13.png";